export default "__VITE_ASSET__D0LXQ5B0__"